import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=c452c2f4&scoped=true&"
import script from "./verified.vue?vue&type=script&lang=js&"
export * from "./verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452c2f4",
  null
  
)

export default component.exports